<div class="video-container">
    <!-- <canvas #inspectorVideoSelf id="inspectorVideoSelf"></canvas> -->
    <video #inspectorVideo autoplay class="inspector-video"></video>
    <!-- <video #inspectorLocalVideo autoplay playsinline style="display: none;"></video> -->
</div>
<div class="controls">
    <button pButton type="button" label="Start Video" (click)="startVideo($event)"></button>
    <button pButton type="button" label="End Session" (click)="endSession()"></button>
    <button pButton type="button" label="Test" (click)="test($event)"></button>
</div>